import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IComando,
  ICreateComando,
  IDispositivoCaravana,
  IListado,
  IQueryParam,
  IUpdateComando,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class ComandosService {
  constructor(private http: HttpService) {}

  public listar(queryParams?: IQueryParam): Observable<IListado<IComando>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/comandos`, { params });
  }

  public crear(dato: ICreateComando): Observable<IComando> {
    return this.http.post(`${api}/comandos`, dato);
  }

  public listarPorId(id: string): Observable<IComando> {
    return this.http.get(`${api}/comandos/${id}`);
  }

  public editar(id: string, dato: IUpdateComando): Observable<IComando> {
    return this.http.put(`${api}/comandos/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/comandos/${id}`);
  }

  //

  public configCaravana(
    deveui: string,
    config: IDispositivoCaravana,
  ): Observable<IComando> {
    return this.http.post(`${api}/comandos/caravana/config`, {
      deveui,
      config,
    });
  }
}
